export const DEFAULT_HANDLEBARS = "{{";
export const DEFAULT_HANDLEBARS_END = "}}";

export const ESCAPE_HANDLEBARS = "{{{";
export const ESCAPE_HANDLEBARS_END = "}}}";

export const HANDLEBAR_TRIGGERS = [{ openingTag: DEFAULT_HANDLEBARS, closingTag: DEFAULT_HANDLEBARS_END }];
export const ESCAPED_HANDLEBAR_TRIGGERS = [{ openingTag: ESCAPE_HANDLEBARS, closingTag: ESCAPE_HANDLEBARS_END }];

export const ESCAPE_BARS_TRIGGERS = [...ESCAPED_HANDLEBAR_TRIGGERS, ...HANDLEBAR_TRIGGERS];

// A small helper to safely escape any regex meta-characters:
function HandebarRegexConvert(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const HANDLEBARS_WRAP = new RegExp(
    HandebarRegexConvert(DEFAULT_HANDLEBARS) + ".*?" + HandebarRegexConvert(DEFAULT_HANDLEBARS_END)
);
export const ESCAPE_BARS_WRAP = new RegExp(
    HandebarRegexConvert(ESCAPE_HANDLEBARS) + ".*?" + HandebarRegexConvert(ESCAPE_HANDLEBARS_END)
);

export const ESCAPE_HIGHLIGHT_LIST = [ESCAPE_BARS_WRAP, HANDLEBARS_WRAP];
